module.exports = __webpack_public_path__ + "assets/ear.797cab3a.svg";